import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ViewHeaderPage } from "./../view-header/view-header";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-vote",
  templateUrl: "shopper-vote.html",
})
export class ShopperVotePage {
  plaza_id: any;
  merchants: any;
  plaza = "";
  selectVote = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController
  ) {
    this.storage.get("info").then((info) => {
      if (info.team.plaza_id == 1) {
        this.plaza = "A";
      } else if (info.team.plaza_id == 2) {
        this.plaza = "B";
      } else if (info.team.plaza_id == 3) {
        this.plaza = "C";
      } else if (info.team.plaza_id == 4) {
        this.plaza = "D";
      } else if (info.team.plaza_id == 5) {
        this.plaza = "E";
      } else if (info.team.plaza_id == 6) {
        this.plaza = "F";
      } else {
        this.plaza = info.team.plaza_id;
      }
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantList;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.merchants = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  vote(merchant_id) {
    const confirm = this.alertCtrl.create({
      title: "Confirm your vote",
      message: `Are you sure vote Merchant ${merchant_id}`,
      buttons: [
        {
          text: "Yes",
          handler: () => {
            const loader = this.loadingCtrl.create({
              content: "Loading...",
            });
            loader.present();

            this.selectVote = merchant_id;

            this.storage.get("token").then((token) => {
              let body = "merchant_id=" + merchant_id;

              var link = this.services.URLShopperVote;
              var headers = new Headers();
              headers.append(
                "Content-Type",
                "application/x-www-form-urlencoded"
              );
              headers.append("Accept", "application/json");
              headers.append("Authorization", "Bearer " + token);
              const requestOptions = new RequestOptions({ headers: headers });

              this.http
                .post(link, body, requestOptions)
                .map((res) => res.json())
                .subscribe(
                  (data) => {
                    loader.dismiss();
                    if (this.storage.set("isVote", 1)) {
                      this.navCtrl.push(ShopperHomePage);
                    }
                  },
                  (error) => {
                    var response = JSON.parse(error._body);
                    loader.dismiss();
                    this.translateService
                      .get(response.message)
                      .subscribe((value) => {
                        this.services.presentToast(value);
                      });
                  }
                );
            });
          },
        },
        {
          text: "No",
          cssClass: "btn-no",
          handler: () => {
            // console.log('Disagree clicked');
          },
        },
      ],
    });
    confirm.present();
  }

  backPage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-vote/shopper-vote.ts